import { useEffect, useState } from "react";
import { LogIn } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { TopBar } from "@/components/TopBar";
import { TextField } from "@/components/tools/fields";
import { AdminDashboard } from "@/components/admin/Dashboard";

const Login = ({ onDone }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onDone(data);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="mx-auto max-w-md space-y-5 rounded-[2rem] border-2 border-line bg-surface p-8" data-testid="admin-login-form">
      <h1 className="font-display text-4xl font-medium">Admin dashboard</h1>
      <p className="text-ink-soft">Private area for the project team.</p>
      <TextField id="admin-email" label="Email" type="email" autoComplete="username" value={email} onChange={setEmail} testid="admin-email" required />
      <TextField id="admin-password" label="Password" type="password" autoComplete="current-password" value={password} onChange={setPassword} testid="admin-password" required />
      {error && <p role="alert" className="font-bold" style={{ color: "var(--rag-red-fg)" }} data-testid="admin-login-error">{error}</p>}
      <button type="submit" disabled={busy} className="btn btn-brand w-full" data-testid="admin-login-submit">
        <LogIn size={16} aria-hidden /> {busy ? "Signing in…" : "Sign in"}
      </button>
    </form>
  );
};

export default function Admin() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      api.post("/auth/refresh").then(() => api.get("/auth/me")).then((r) => setUser(r.data)).catch(() => setUser(false));
    });
  }, []);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => null);
    setUser(false);
  };
  return (
    <>
      <TopBar minimal />
      <main id="main" tabIndex={-1} className="mx-auto min-h-screen max-w-6xl px-5 pb-24 pt-40 outline-none sm:px-8">
        {user === null ? <p>Checking your session…</p> : user ? <AdminDashboard user={user} onLogout={logout} /> : <Login onDone={setUser} />}
      </main>
    </>
  );
}
